<template>
  <section>
    <z-dialog :show="isVisible" :modal-size="modalSize" :d-style="'z-index: 1070'" :bd-style="'z-index: 1065'">
      <template #header>
        <div class="row custom-header">
          <div class="col">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <template #body>
        <div class="custom-body">
          <alldata-links :links="links" />
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col-1">
            <span title="id">{{ id }}</span>
          </div>
          <div class="col">
            <z-message v-model="message" class="alert alert-warning mt-2" />
          </div>
          <div class="col-4 custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </section>
</template>
<script>
import { mapState } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
import AlldataLinks from './alldata-links.vue'
export default {
  name: 'DialogPreviewLink',
  components: {
    ZDialog,
    ZMessage,
    AlldataLinks
  },
  props: {
    modelValue: Object
  },
  emits: ['closing'],
  data() {
    return {
      modalSize: 'modal-lg',
      message: null
    }
  },
  computed: {
    ...mapState(adasmatrixStore, ['adasLink']),
    isVisible() {
      return this.modelValue !== null
    },
    title() {
      let _title = 'Previewing Links'
      return _title
    },
    id() {
      let _id = ''
      if (this.modelValue) {
        _id = `${this.modelValue.adasLinks}`
      }
      return _id
    },
    links() {
      let _data = null
      if (this.adasLink) {
        if (this.adasLink.links !== '') {
          _data = JSON.parse(this.adasLink.links)
        }
      }
      return _data
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    },
    showMessage(message) {
      this.message = message
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  color: #000;
  cursor: pointer;
}
.custom-body {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.hostWrapper {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
